<template>
<div id="interpretationCreation">
  <div v-for="(response, index) in interpretationsList" :key="index">
    <h5> Annotations pour la réponse [{{response.rousselotPhoneticForm}}]</h5>
    <b-card no-body class="mb-1" v-for="(interpretation) in response.interpretationList" :key="interpretation.interpretationId">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle="'interp' + interpretation.interpretationId" @click="findRelatedInventoryEntries(interpretation)"> Annotation de {{ interpretation.user.username }} -
          {{interpretation.user.organization}}</b-button>
      </b-card-header>
      <b-collapse :id="'interp' + interpretation.interpretationId" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text v-if="(currentUser.username != interpretation.user.username && interpretation.confidentiality === 'confidentielle') || (!isAuthenticated && interpretation.confidentiality === 'restreinte') ">
            <b-alert show variant="info">Annotation confidentielle</b-alert>
          </b-card-text>
          <b-card-text v-if="(isAuthenticated && interpretation.confidentiality === 'restreinte') || currentUser.username === interpretation.user.username || interpretation.confidentiality === 'publique'">
            <b-tabs content-class="mt-3">
              <b-tab title="Général" active>
                <b-list-group>
                  <b-list-group-item>
                    Confidentialité : {{ interpretation.confidentiality }}
                  </b-list-group-item>
                  <b-list-group-item>
                    Réponse lémmatisée : {{interpretation.lemmatizedResponse}}
                  </b-list-group-item>
                  <b-list-group-item>
                    Type: {{interpretation.responseType}}
                  </b-list-group-item>
                  <b-list-group-item>
                    Motif: {{interpretation.ground}}
                  </b-list-group-item>
                  <b-list-group-item>
                    Motif spécifique: {{interpretation.specificGround}}
                  </b-list-group-item>
                  <b-list-group-item>
                    Désignant: {{interpretation.designating}}
                  </b-list-group-item>
                  <b-list-group-item>
                    Commentaire: <div v-html="interpretation.interpretationComment">{{interpretation.interpretationComment}}</div>
                  </b-list-group-item>
                </b-list-group>
              </b-tab>
              <b-tab v-for="(lemma, lemmasIndex) in interpretation.lemmasList" :title="'Lemme n°' + (lemmasIndex + 1)" :key="lemmasIndex">
                <b-list-group>
                  <b-list-group-item>
                    Nature Grammaticale: {{lemma.grammaticalNature}}
                  </b-list-group-item>
                  <b-list-group-item>
                    Genre: {{lemma.gender}}
                  </b-list-group-item>
                  <b-list-group-item>
                    Nombre: {{lemma.number}}
                  </b-list-group-item>
                  <b-list-group-item>
                    Commentaire:
                    <div v-html="lemma.lemmaComments"> {{lemma.lemmaComments}}</div>
                  </b-list-group-item>
                </b-list-group>
                <br>
                <h5> Étymons du lemme {{lemmasIndex + 1}}</h5>
                <b-tabs pills card vertical>
                  <b-tab :title="'Etymon ' + (etymonsIndex + 1)" v-for="(etymon, etymonsIndex) in lemma.etymonsList" :key="etymonsIndex">
                    <b-list-group>
                      <b-list-group-item>
                        Incertitude : {{etymon.uncertainty}}
                      </b-list-group-item>
                      <b-list-group-item>
                        Étymon FEW : {{etymon.fewEtymon}}
                      </b-list-group-item>
                      <b-list-group-item>
                        Origine langue : {{etymon.fewEtymonLanguage}}
                      </b-list-group-item>
                      <b-list-group-item>
                        Signifié : {{etymon.fewEtymonSignified}}
                      </b-list-group-item>
                      <b-list-group-item>
                        Ref. FEW : {{etymon.fewEtymonReference}}
                      </b-list-group-item>
                      <b-list-group-item>
                        Commentaire étymon : <div v-html="etymon.etymonComment"> {{etymon.etymonComment}} </div>
                      </b-list-group-item>
                    </b-list-group>
                  </b-tab>
                </b-tabs>
              </b-tab>
              <b-tab title="Éditer" v-if="currentUser.username == interpretation.user.username">
                <b-button variant="success" @click="editInterpretation(interpretation, response.rousselotPhoneticForm)">Editer cette annotation</b-button>
              </b-tab>
              <b-tab title="Supprimer" v-if="currentUser.username == interpretation.user.username">
                <p class="alert-danger" id="deleteTabContent">Supprimer cette annotation, attention cette action est irréversible
                  <br>
                  <b-button variant="danger" @click="deleteInterpretation(interpretation)">Supprimer</b-button>
                </p>
              </b-tab>
            </b-tabs>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InterpretationsConsultation',
  computed: {
    ...mapGetters({
      interpretationsList: 'getInterpretationsList',
      currentMap: 'getCurrentMap',
      isAuthenticated: 'getIsAuthenticated',
      currentUser: 'getCurrentUser'
    })
  },
  methods: {
    deleteInterpretation: function(interpretation) {
      this.$store.dispatch('deleteInterpretation', { interpretation: interpretation, mapId: this.currentMap, isEdition: false })
    },
    editInterpretation: function(interpretation, rousselotPhoneticForm) {
      this.$emit('openEdition', { interpretation: interpretation, rousselotPhoneticForm: rousselotPhoneticForm })
    },
    // Recherche des entrées d'inventaires concernées par l'annotation consultée
    findRelatedInventoryEntries: function(interpretation) {
      this.$store.dispatch('findRelatedInventoryEntries', interpretation.interpretationId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/commons/sideBarViewer/interpretationsSideBar/InterpretationsConsultation.vue